export default __webpack_public_path__ + "static/media/sebastien-gabrieles.55254281.jpg";